import React from 'react'

export function useStickyHeaderSx(): Record<string, unknown> | undefined {
  // TODO: set this to be a setting in the more file options menu
  const shouldUseStickyHeaders = true
  const stickySx = React.useMemo(() => {
    return shouldUseStickyHeaders
      ? {
          top: '0px',
          zIndex: 4,
          background: 'var(--bgColor-default, var(--color-canvas-default))',
          position: shouldUseStickyHeaders ? 'sticky' : undefined,
        }
      : undefined
  }, [shouldUseStickyHeaders])

  return stickySx
}
